/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RemoteActionJobParameters } from './RemoteActionJobParameters';
export type RemoteActionJobCreateDto = {
  /**
   * List of Devices Serial Number
   */
  devices?: Array<string>;
  /**
   * List of Device group ids
   */
  deviceGroups?: Array<number>;
  /**
   * Remote Action name to perform
   */
  action: RemoteActionJobCreateDto.action;
  parameters?: RemoteActionJobParameters;
};
export namespace RemoteActionJobCreateDto {
  /**
   * Remote Action name to perform
   */
  export enum action {
    REBOOT = 'REBOOT',
    LOG_REQUEST = 'LOG_REQUEST',
    FIRMWARE_UPDATE = 'FIRMWARE_UPDATE',
    COMMAND = 'COMMAND',
  }
}

